import { render, staticRenderFns } from "./RebuttalNotifyDialog.vue?vue&type=template&id=32a2226e&scoped=true&"
import script from "./RebuttalNotifyDialog.vue?vue&type=script&lang=js&"
export * from "./RebuttalNotifyDialog.vue?vue&type=script&lang=js&"
import style0 from "./RebuttalNotifyDialog.vue?vue&type=style&index=0&id=32a2226e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a2226e",
  null
  
)

export default component.exports